export const roleSorter = <T>(
  list: T[],
  roleParam: string = 'boardFunction',
  nameParam?: string
) => {
  if (!list.length) return []
  const roles = [
    'Styreleder',
    'Nestleder',
    'Styremedlem',
    'Varamedlem',
    'Sekretær',
    'Kasserer',
    'BBL-representant',
    'Revisor',
    'Daglig leder',
    'Digitale nøkler',
    'Annet',
    '(ikke lengre i styret)',
    // No role / external
    null,
    'Ekstern',
    '',
  ]

  // To make indexing more efficient
  const map = new Map()
  roles.forEach((role, i) => map.set(role, i))

  // sort list depending on roles
  const sorted = new Array(...list).sort((x, y) => {
    const a = x[roleParam as keyof T]
    const b = y[roleParam as keyof T]

    if (nameParam && a === b) {
      const nameX = x[nameParam as keyof T]
      const nameY = y[nameParam as keyof T]

      if (nameX < nameY) return -1
      if (nameX > nameY) return 1
      return 0
    }

    return map.get(a) - map.get(b)
  })

  return sorted
}
